import { useTheme as _useTheme } from 'foundations-theming-specialty/utils';
import { isDarkTheme, isTrellisTheme } from 'foundations-theming/utils';
export const useTheme = () => {
  const theme = _useTheme();
  const isTrellis = isTrellisTheme(theme);
  const isDark = isDarkTheme(theme);
  const color = theme.color;
  return Object.assign({}, theme, {
    /**
     * @todo remove hard coded values if we remove SVG gradients
     * or if we can get tokens from the theme
     * Alternatively, we could parse the CSS gradient, but that
     * seems fragile
     */
    breezeGradientColors: {
      darkStop: color['breeze-fill-special-btn-alt-disabled'],
      mediumStop: '#fb31a7',
      lightStop: '#fbddd2'
    },
    isTrellisLight: isTrellis && !isDark,
    isTrellisDark: isTrellis && isDark
  });
};